import {
  resolveTimelineDrop,
  ResolveTimelineDropOptions,
} from '@griply/services';
import {
  GoalLifeAreaLinkChange,
  GoalParentLinkChange,
  GoalReorderSectionUpdate,
  UpdateGoal,
} from '@griply/types';
import { useCallback } from 'react';

export const useTimelineDropReorder = (
  onReorder: (
    updatedSections: GoalReorderSectionUpdate[],
    updatedGoals: UpdateGoal[],
    goalLinkChanges?: GoalLifeAreaLinkChange[],
    goalParentChanges?: GoalParentLinkChange[],
  ) => void,
) =>
  useCallback(
    (drop: ResolveTimelineDropOptions) => {
      const update = resolveTimelineDrop(drop);
      if (!update) {
        return;
      }
      onReorder(
        update.updatedSections,
        update.updatedGoals,
        update.goalLifeAreaChanges,
        update.goalParentChanges,
      );
    },
    [onReorder],
  );
